import { GetStaticProps, NextPage } from 'next';

import AndonPage from '@/views/andon/andon-page';

const Andon: NextPage = () => {
  return <AndonPage />;
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {
    namespaces: ['andon'],
  },
});

export default Andon;
